import React, { useState, useEffect } from 'react';
import { createClient } from '@supabase/supabase-js';
import VideoHistory from './components/VideoHistory';

// 🚨 1. LA CONNEXION À TA BASE DE DONNÉES
const supabaseUrl = 'https://lgsddceccsvmrnfimxjy.supabase.co'; 
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxnc2RkY2VjY3N2bXJuZmlteGp5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI1OTEzODUsImV4cCI6MjA3ODE2NzM4NX0.OZ1RJSPOjQEL1n4JYMjD-r0t34JQi_w5x4dcqRPSCfQ'; // <-- COPIE/COLLE TA CLÉ SUPABASE ICI
export const supabase = createClient(supabaseUrl, supabaseKey);

function App() {
  const [session, setSession] = useState(null);
  
  // États pour la navigation de l'Auth
  const [authMode, setAuthMode] = useState('login'); // 'login', 'signup', ou 'forgot'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // 👁️ Toggle mot de passe
  const [authError, setAuthError] = useState('');
  const [authMessage, setAuthMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAuthError('');
    setAuthMessage('');
    
    try {
      if (authMode === 'login') {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
      } else if (authMode === 'signup') {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        setAuthMessage('Inscription réussie ! Vous pouvez maintenant vous connecter.');
        setAuthMode('login');
      } else if (authMode === 'forgot') {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: 'https://app.smart-highlights.ai/',
        });
        if (error) throw error;
        setAuthMessage('Un lien de réinitialisation a été envoyé à votre adresse email.');
        setAuthMode('login');
      }
    } catch (error) {
      setAuthError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // 🇬 Connexion avec Google
  const handleGoogleLogin = async () => {
      setLoading(true);
      const { error } = await supabase.auth.signInWithOAuth({
          provider: 'google',
          options: {
              redirectTo: 'https://app.smart-highlights.ai/'
          }
      });
      if (error) setAuthError(error.message);
      setLoading(false);
  };

  // --- L'ÉCRAN DE CONNEXION ---
  if (!session) {
    return (
      <div style={{minHeight: '100vh', backgroundColor: '#0f172a', color: '#f1f5f9', display: 'flex', flexDirection: 'column', fontFamily: "'Inter', sans-serif"}}>
        
        <header style={{ padding: '15px 40px', backgroundColor: '#0f172a', borderBottom: '1px solid #1e293b', display: 'flex', alignItems: 'center' }}>
          <div style={{ width: '32px', height: '32px', background: 'linear-gradient(135deg, #06b6d4, #3b82f6)', borderRadius: '8px', marginRight: '15px' }} />
          <h1 style={{ color: '#fff', fontSize: '1.3rem', fontWeight: '700', margin: 0 }}>smart-highlights.ai</h1>
        </header>

        <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'}}>
          <div className="bg-slate-900 p-10 rounded-3xl border border-slate-800 shadow-2xl w-full max-w-md animate-in fade-in zoom-in-95 duration-500">
            <div className="text-center mb-8">
              <span className="text-5xl mb-4 block">🔒</span>
              <h2 className="text-2xl font-black text-white">Portail <span className="text-indigo-500">Arrow</span></h2>
              <p className="text-slate-400 text-sm mt-2">Connectez-vous pour accéder au moteur IA.</p>
            </div>

            {/* 🇬 Bouton Google */}
            {authMode !== 'forgot' && (
                <div className="mb-6">
                    <button onClick={handleGoogleLogin} disabled={loading} className="w-full bg-white hover:bg-slate-100 text-slate-900 font-bold py-3 px-4 rounded-xl shadow-lg active:scale-95 transition-all flex items-center justify-center gap-3">
                        <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/><path fill="none" d="M1 1h22v22H1z"/></svg>
                        Continuer avec Google
                    </button>
                    <div className="flex items-center my-6">
                        <div className="flex-grow border-t border-slate-700"></div>
                        <span className="flex-shrink-0 mx-4 text-slate-500 text-xs uppercase tracking-wider font-bold">Ou avec votre email</span>
                        <div className="flex-grow border-t border-slate-700"></div>
                    </div>
                </div>
            )}

            <form onSubmit={handleAuth} className="space-y-5">
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full bg-slate-800 border border-slate-700 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition-all" placeholder="votre@email.com" />
              </div>
              
              {authMode !== 'forgot' && (
                <div className="relative">
                  <div className="flex justify-between items-end mb-2">
                      <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider">Mot de passe</label>
                      {authMode === 'login' && (
                          <button type="button" onClick={() => setAuthMode('forgot')} className="text-xs text-indigo-400 hover:text-indigo-300">Oublié ?</button>
                      )}
                  </div>
                  <div className="relative">
                      <input 
                          type={showPassword ? "text" : "password"} // 👁️ Gère l'affichage du mot de passe
                          value={password} 
                          onChange={(e) => setPassword(e.target.value)} 
                          required 
                          className="w-full bg-slate-800 border border-slate-700 rounded-xl pl-4 pr-12 py-3 text-white focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition-all" 
                          placeholder="••••••••" 
                      />
                      <button 
                          type="button" 
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white p-1"
                      >
                          {showPassword ? '🙈' : '👁️'}
                      </button>
                  </div>
                </div>
              )}

              {authError && <div className="text-red-400 bg-red-500/10 border border-red-500/20 p-3 rounded-lg text-sm text-center">{authError}</div>}
              {authMessage && <div className="text-green-400 bg-green-500/10 border border-green-500/20 p-3 rounded-lg text-sm text-center">{authMessage}</div>}

              <button type="submit" disabled={loading} className="w-full bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-500 hover:to-violet-500 text-white font-bold py-3 px-4 rounded-xl shadow-lg active:scale-95 transition-all flex items-center justify-center gap-2 mt-4">
                {loading ? <span className="animate-spin">⚙️</span> : (authMode === 'login' ? 'Se Connecter' : authMode === 'signup' ? 'Créer mon compte' : 'Envoyer le lien')}
              </button>
            </form>

            <div className="mt-8 text-center">
              {authMode === 'forgot' ? (
                  <button onClick={() => setAuthMode('login')} className="text-sm text-slate-500 hover:text-indigo-400 transition-colors">← Retour à la connexion</button>
              ) : (
                  <button onClick={() => setAuthMode(authMode === 'login' ? 'signup' : 'login')} className="text-sm text-slate-500 hover:text-indigo-400 transition-colors">
                    {authMode === 'login' ? "Pas encore de compte ? S'inscrire" : "Déjà un compte ? Se connecter"}
                  </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 🚨 4. LE STUDIO (Si tu es connecté)
  return (
    <div style={{minHeight: '100vh', backgroundColor: '#0f172a', color: '#f1f5f9', fontFamily: "'Inter', sans-serif"}}>
      <VideoHistory user={session.user} onLogout={() => supabase.auth.signOut()} />
      <footer style={{textAlign: 'center', padding: '40px 0', color: '#475569', fontSize: '0.8rem', borderTop: '1px solid #1e293b', marginTop: '40px'}}>
        <p>&copy; 2026 Arrow AI • Powered by SmartHighlights Engine</p>
      </footer>
    </div>
  );
}

export default App;
